import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const saved = localStorage.getItem('lr_cart');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('lr_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (book, format) => {
    const key = `${book.id}-${format}`;
    setItems((prev) => {
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, qty: i.qty + 1 } : i));
      }
      return [
        ...prev,
        {
          key,
          id: book.id,
          title: book.title,
          subtitle: book.subtitle,
          image: book.front,
          format,
          price: format === 'physical' ? book.physical : book.digital,
          qty: 1,
        },
      ];
    });
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const updateQty = (key, qty) =>
    setItems((prev) =>
      prev.map((i) => (i.key === key ? { ...i, qty: Math.max(1, qty) } : i))
    );
  const clearCart = () => setItems([]);

  const count = items.reduce((n, i) => n + i.qty, 0);
  const total = items.reduce((n, i) => n + i.qty * i.price, 0);
  const hasPhysical = items.some((i) => i.format === 'physical');

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, updateQty, clearCart, count, total, hasPhysical }}
    >
      {children}
    </CartContext.Provider>
  );
};
